// Types
import { IconsEnum } from '@utmb/types/icons';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
// Style
import styles from './more-info-dialog.module.scss';
import '@reach/dialog/styles.css';

export interface MoreInfoDialogProps {
    title: string;
    message: string;
    isOpen: boolean;
    onClose: () => void;
}

const MoreInfoDialog = (props: MoreInfoDialogProps) => {
    const { title, message, isOpen, onClose } = props;
    return (
        <div className={styles.modal} style={{ display: isOpen ? 'block' : 'none' }}>
            <div className={styles.modal_container}>
                <button className={styles.button_close} onClick={onClose}>
                    <Icon variant={IconsEnum.CLOSE} clss="color-secondary" />
                </button>
                <div className={styles.title}>
                    <Font.OxaniumLight mobile="20" desktop="24" className={styles.title}>
                        {title}
                    </Font.OxaniumLight>
                </div>

                <div className={styles.message_wrapper}>
                    <Font.OxaniumBold className={styles.service_label} mobile="14" desktop="16" color="var(--utmb-ws-color-primary)">
                        <span dangerouslySetInnerHTML={{ __html: message }} />
                    </Font.OxaniumBold>
                </div>
            </div>
        </div>
    );
};

export default MoreInfoDialog;
